/**
 * Setting up a campaign from the invoicing workspace (IN-1718, Flow 1 step 1).
 *
 * Harish's flow starts with the business team setting the project up in the
 * workspace; until now the workspace could only find campaigns that already
 * existed somewhere else. This shapes and checks the form for creating one,
 * against the brand campaign endpoint the planner already uses.
 */

/** `{field: message}`; empty means valid. */
export function validateNewCampaign(form) {
  const values = form || {};
  const errors = {};

  if (!String(values.name || '').trim()) {
    errors.name = 'Give the campaign a name.';
  }

  const start = String(values.start_date || '').trim();
  const end = String(values.end_date || '').trim();

  // Dates are optional, but half a range is worse than none: the invoice
  // console filters on them and a missing end would silently widen the window.
  if (start && !end) {
    errors.end_date = 'Add the end date too, or clear the start date.';
  }
  if (end && !start) {
    errors.start_date = 'Add the start date too, or clear the end date.';
  }
  if (start && end && end < start) {
    errors.end_date = 'The end date cannot be before the start date.';
  }

  return errors;
}

/** The request body; blank dates are omitted rather than sent as "". */
export function newCampaignPayload(form) {
  const values = form || {};
  const start = String(values.start_date || '').trim();
  const end = String(values.end_date || '').trim();

  return {
    name: String(values.name || '').trim(),
    ...(start ? { start_date: start } : {}),
    ...(end ? { end_date: end } : {}),
  };
}
